import { defineMessages } from 'react-intl';

const translations = {
  invoiceCard: {
    status: {
      paid: {
        id: 'properties.paid',
        defaultMessage: 'Paid',
        description: 'label of the paid status',
      },
      unpaid: {
        id: 'properties.unpaid',
        defaultMessage: 'Unpaid',
        description: 'label of the unpaid status',
      },
    },
    includingVat: {
      id: 'properties.includingVat',
      defaultMessage: 'Incl. VAT',
      description: 'label of the including VAT setting',
    },
    excludingVat: {
      id: 'properties.excludingVat',
      defaultMessage: 'Excl. VAT',
      description: 'label of the excluding VAT setting',
    },
  },
};

export default defineMessages(translations);
